module.exports = __webpack_public_path__ + "img/xr_m_1.3b3c6636.jpg";